// Import the edliy_utils
import {
    makeResponsive,
    placeTitle,
    placeImage,
    placeInput,
    placeSlider,
    hoverMe,
    placeRec,
    hiddenPt,
    fixedPt,
    clearInputFields,
    dragMe,
    placeArrow,
    placeGravity,
    placeText,
    placeLine,
    placePoint,
    placeGlider,
    placeRuler,
    placeLeftText,
    placeCircle,
    placeAngle,
    placeDash,
    placeLabel
} from '../../../common/edliy_utils';
const Boxes = {
  box1: function () {
    JXG.Options.layer['ticks']=2;
    JXG.Options.layer['polygon']=2;
    JXG.Options.layer['line']=2;
    JXG.Options.layer['text']=3;
    JXG.Options.layer['point']=5;
    var brd = JXG.JSXGraph.initBoard('jxgbox1', {boundingbox:[-4.25,4.25,4.25,-4.25], axis:false, keepaspectratio:true, showNavigation:false, showCopyright:false});
    brd.suspendUpdate();
    //Make the board responsive
    makeResponsive(brd);
    // Creat titleStyle
    placeTitle(brd, 'Refraction of Light', '(Drag Laser Light P to Change Incident Angle.)');
    //Origin
    var origin=brd.create('point',[0,0], {visible:false, fixed:true});
    //LeftMost
    var lt=brd.create('point',[-4,0], {visible:false, fixed:true});
    //RightMost
    var Rt=brd.create('point',[4,0], {visible:false, fixed:true});
    //Titles
    var med1 = brd.create('text',[-2.5, 3.5, 'Medium#1'], {fontSize:20, fixed:true});
    var med2 = brd.create('text',[2.0,  3.5, 'Medium#2'], {fontSize:20, fixed:true});
    //Interface
    var boundary = brd.create('segment', [[0.0, -4],[-0.0,4]], {strokeColor:'grey', strokeWidth:3, visible:false});
    //Medium#1
    var rect = brd.create('polygon',[[0.0,-4.25],[-0.0, 4.25],[-4.25,4.25],[-4.25, -4.25]],{fillColor:'lightblue', strokeColor:'black', strokeWidth:5, withLines:false, fillOpacity:1, vertices:{visible:false}});
    //Left track
    var circ =brd.create('arc',[[0,0], [3.75,0], [0, 3.75]], {visible:false, center:{size:0, name:''}, radiuspoint:{size:0, name:''}, anglepoint:{size:0, name:''}, center:{size:0, name:''}});
    //Right track
    var arcc =brd.create('arc', [[0,0], [-4.,0],[0, -4.]], {visible:false, radiuspoint:{size:0, name:''}, anglepoint:{size:0, name:''}, center:{size:0, name:''}});
    // Torch
    var torch = brd.create('glider',[-2*Math.cos(Math.PI/4),-2*Math.sin(Math.PI/4), arcc],{name:'Drag me!', size:4, face:'circle', strokeColor:'black', shadow:true});
    //IncidentRay
    var inc =brd.create('line', [[0, 0], torch], {strokeWidth:4, strokeColor:'red', straightFirst:true, vertices:{visible:false}});
    var a=brd.create('angle',[lt,origin,torch], {name:'i_a', strokeColor:'black', fillOpacity:0, radius:1, Label:{fontSize:24, Color:'red'}});
    //Rotation transfrom
    var irot = brd.create('transform', [function(){return JXG.toFixed(a.Value(),2);}, 0, 0], {type:'rotate'});
    var Ptsi=[]; var Perpsi=[]; var Intersi=[]; var Ticki=[];
    var i;
    for(i=0; i<10; i++){
    Ptsi[i] = brd.create('point', [-(i+1)*1+5, 0 ], {name:'', visible:false});
    Perpsi[i] = brd.create('perpendicular',[Ptsi[i], inc], {strokeWidth:0.25, strokeColor:'red',visible:true, dash:1});
    Intersi[i] = brd.create('intersection',[Perpsi[i], boundary], {name:function(i){return function(){return 4-i;};}(i), face:'square', size:4, fillColor:'red', strokeColor:'red', fillOpacity:1, visible:false});
    //Ticki[i]= brd.create('line',[Intersi[i], Ptsi[i]], {strokeWidth:0.25, strokeColor:'red', visible:false});
    };
    irot.bindTo(Ptsi);
    //var front = brd.create('ticks', [inc],{ticksDistance:1.0, minorTicks:0, majorHeight:-1, strokeColor:'red', drawZero:true});
    //Eye
    var eye = brd.create('glider',[2,0, circ],{name:'Drag me!', size:4, face:'circle', strokeColor:'black',fillColor:'yellow',shadow:true});
    //Transmitted Angle
    var b =brd.create('angle',[Rt,origin,eye], {name:'r_a', fillOpacity:0, radius:1, strokeColor:'black', Label:{fontSize:24, Color:'blue'}});
    //Medium#2
    var punch = brd.create('polygon',[[0.0,-4.25],[-0.0, 4.25],[4.25,4.25],[4.25, -4.25]],{fillColor:'lightyellow', strokeColor:'black', strokeWidth:5, withLines:false, fillOpacity:1, vertices:{visible:false}});
    //var origin = brd.create('point',[0,0],{name:'', size:0});
    //1st
    var mu1 = brd.create('slider', [[1,-1.], [3,-1], [1,1,2]], {name:'mu_1', face:'square'});
    //2nd
    var mu2 = brd.create('slider', [[1,-1.5], [3,-1.5], [1,1,2]], {name:'mu_2', face:'square'});
    //
    var normal =brd.create('perpendicular', [origin,boundary], {dash:1, strokeWidth:1});
    //Transmitted Ray
    var tran = brd.create('line', [[0, 0], eye], {strokeWidth:4, straightFirst:false, vertices:{visible:false}});
    //Waveform#1
    var sineinc =brd.create('functiongraph', [function(x){return 0.25*Math.sin(2*Math.PI*x);}, -8, 0],{strokeColor:'red'});
    irot.bindTo(sineinc);
    var sinetrans =brd.create('functiongraph', [function(x){return 0.25*Math.sin(2*Math.PI*x*mu2.Value()/mu1.Value());}, 0, 8]);
    // Lattice Points and Segments
    var trot = brd.create('transform', [function(){return JXG.toFixed(b.Value(),2);}, 0, 0], {type:'rotate'});
    trot.bindTo(sinetrans);
    var i; var Pts=[]; var Perps=[]; var Inters=[]; var Tick=[];
    for(i=0; i<10; i++){
    Pts[i] = brd.create('point', [function(i){return function(){return (mu1.Value()/mu2.Value())*(i)*Math.cos(b.Value());};}(i),function(i){return function(){return (mu1.Value()/mu2.Value())*(i)*Math.sin(b.Value());};}(i) ], {name:'', visible:false});
    Perps[i] = brd.create('perpendicular',[Pts[i], tran], {visible:false, strokeWidth:0.5, strokeColor:'blue', dash:1, minX:0});
    Inters[i] = brd.create('intersection',[Perps[i], boundary], {name:'', face:'square', fillColor:'blue',size:4, strokeColor:'blue',  fillOpacity:1, visible:false});
    Tick[i]= brd.create('line',[Inters[i], Pts[i]], {straightFirst:false, strokeWidth:0.5, strokeColor:'blue', dash:1, visible:true});
    };
    brd.create('line', [[0,0],[function(){return 10*Math.sin(b.Value());}, function(){return -10*Math.cos(b.Value());}]],{strokeWidth:0.5, strokeColor:'blue', dash:1, visible:true, straightFirst:false});
    Inters[0].setAttribute({visible:function(){if(JXG.toFixed(Inters[1].Y(),1) == JXG.toFixed(Intersi[3].Y(),1)){return true;} else {return false;}}});
    Inters[1].setAttribute({visible:function(){if(JXG.toFixed(Inters[1].Y(),1) == JXG.toFixed(Intersi[3].Y(),1)){return true;} else {return false;}}});
    Inters[2].setAttribute({visible:function(){if(JXG.toFixed(Inters[2].Y(),1) == JXG.toFixed(Intersi[2].Y(),1)){return true;} else {return false;}}});
    Inters[3].setAttribute({visible:function(){if(JXG.toFixed(Inters[3].Y(),1) == JXG.toFixed(Intersi[1].Y(),1)){return true;} else {return false;}}});
    var ang1 = brd.create('text',[2.0,-2.5, function(){return 'i_a =' + JXG.toFixed(a.Value()*180/Math.PI,2);}], {fontSize:20, fixed:true});
    //var ang2 = brd.create('text',[2.0,-3, function(){return 'r_a =' +JXG.toFixed(b.Value()*180/Math.PI,1);}], {fontSize:20, fixed:true});
    var ang2 = brd.create('text',[2.0,-3., function(){if(JXG.toFixed(Inters[1].Y(),1) == JXG.toFixed(Intersi[3].Y(),1)){return 'r_a =' +JXG.toFixed(Math.asin(mu1.Value()*Math.sin(a.Value())/mu2.Value())*180/Math.PI,2);} else {return 'r_a =' +JXG.toFixed(b.Value()*180/Math.PI,2);};}], {fontSize:20, fixed:true});
    brd.unsuspendUpdate();
}
}
export default Boxes;
